import CommentsListHelper from "./comments-list-helper";
import CommentsBackendHelper from "./comments-backend-helper";

const CommentsHelpers = {
    ...CommentsListHelper,
    ...CommentsBackendHelper,
};

export default CommentsHelpers;
